import { ArrowForward, Done } from "@mui/icons-material";
import { Box, TextField, Typography } from "@mui/material";

import { SalesAidsStyles } from "./SalesAidsStyles";
import dealerRater from "../../../../../assets/images/dealer-rater.jpg";
import FaceBook from "../../../../../assets/images/facebook.png";
import google from "../../../../../assets/images/googeReview.png";
import Theme from "../../../../../utils/Theme";

const ReviewComponent = ({ artifacts, setArtifacts, handleArrowClick }) => {
  const handleTextChange = (field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      review: {
        ...prev.review,
        [field]: value,
        isEdit: true,
      },
    }));
  };

  const isReview = () => {
    const {
      review_question,
      es_review_question,
      second_review_question,
      es_second_review_question,

      referral_question,
      es_referral_question,
      message,
      es_message,
      facebook,
      google,
      dealer_rater,
    } = artifacts || {};
    return (
      (review_question?.trim() || es_review_question?.trim()) &&
      (second_review_question?.trim() || es_second_review_question?.trim()) &&
      (referral_question?.trim() || es_referral_question?.trim()) &&
      (message?.trim() || es_message?.trim()) &&
      (facebook?.trim() || google?.trim() || dealer_rater?.trim())
    );
  };

  return (
    <Box
      sx={{
        ...SalesAidsStyles.outerBox,
        gap: 2,
        p: "6px",
        bgcolor: artifacts?.isEdit ? "#FFF7F7" : null,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        {/* Satisfaction Message Row */}
      
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={SalesAidsStyles.wordStyle}>English</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label="Initial CSI Question"
              onChange={(e) =>
                handleTextChange("review_question", e.target.value)
              }
              sx={{ mt: 2 }}
              value={artifacts?.review_question || ""}
              multiline
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={SalesAidsStyles.wordStyle}>Spanish</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label="Pregunta inicial de CSI"
              onChange={(e) =>
                handleTextChange("es_review_question", e.target.value)
              }
              sx={{ mt: 2 }}
              value={artifacts?.es_review_question || ""}
              multiline
            />
          </Box>
          {/* Action Button (Tick or Arrow) */}
          {artifacts?.isEdit ? (
            <Done
              sx={{
                fontSize: 14,
                mt: 4,
                alignSelf: "center",
                color: isReview()
                  ? Theme.palette.primary.main
                  : Theme.palette.action.disabled,
                cursor: isReview() ? "pointer" : "not-allowed",
              }}
              onClick={() => {
                if (isReview()) {
                  // ✅ Call parent function
                  handleArrowClick(artifacts, "video");

                  // ✅ Reset background color (turn red to white)
                  setArtifacts((prev) => ({
                    ...prev,
                    review: {
                      ...prev.review,
                      isEdit: false,
                    },
                  }));
                }
              }}
            />
          ) : (
            <ArrowForward
              sx={{
                fontSize: 14,
                mt: 4,
                alignSelf: "center",
                color: isReview()
                  ? Theme.palette.primary.main
                  : Theme.palette.action.disabled,
                cursor: isReview() ? "pointer" : "not-allowed",
              }}
              onClick={() => isReview() && handleArrowClick(artifacts, "video")}
            />
          )}
        </Box>

 <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Second CSI Question"
            onChange={(e) =>
              handleTextChange("second_review_question", e.target.value)
            }
            value={artifacts?.second_review_question || ""}
            multiline
          />
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Segunda pregunta del CSI"
            onChange={(e) =>
              handleTextChange("es_second_review_question", e.target.value)
            }
            value={artifacts?.es_second_review_question || ""}
            multiline
          />
        </Box>

        {/* Referral Message Row */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Referral message"
            onChange={(e) =>
              handleTextChange("referral_question", e.target.value)
            }
            value={artifacts?.referral_question || ""}
            multiline
          />
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Mensaje de referencia"
            onChange={(e) =>
              handleTextChange("es_referral_question", e.target.value)
            }
            value={artifacts?.es_referral_question || ""}
            multiline
          />
        </Box>

        {/* Review Message Row */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Review message"
            onChange={(e) => handleTextChange("message", e.target.value)}
            value={artifacts?.message || ""}
            multiline
          />
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Revisar mensaje"
            onChange={(e) => handleTextChange("es_message", e.target.value)}
            value={artifacts?.es_message || ""}
            multiline
          />
        </Box>

        {/* Social Media Links (Side by Side English & Spanish URL if needed) */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <img src={FaceBook} width={30} alt="Facebook" />
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Facebook Link"
            onChange={(e) => handleTextChange("facebook", e.target.value)}
            value={artifacts?.facebook || ""}
            multiline
          />
        </Box>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <img src={google} width={30} alt="Google" />
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="Google Link"
            onChange={(e) => handleTextChange("google", e.target.value)}
            value={artifacts?.google || ""}
            multiline
          />
        </Box>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <img src={dealerRater} width={30} alt="DealerRater" />
          <TextField
            sx={{ flex: 1 }}
            variant="outlined"
            label="DealerRater Link"
            onChange={(e) => handleTextChange("dealer_rater", e.target.value)}
            value={artifacts?.dealer_rater || ""}
            multiline
          />
        </Box>
      </Box>

      {/* Action Buttons
      {artifacts?.isEdit ? (
        <Done
          sx={{
            fontSize: 20,
            mt: "10px",
            alignSelf: "flex-start",
            color: isReview()
              ? Theme.palette.primary.main
              : Theme.palette.action.disabled,
            cursor: isReview() ? "pointer" : "not-allowed",
          }}
          onClick={() => handleArrowClick(artifacts, "review")}
        />
      ) : (
        <ArrowForward
          sx={{
            fontSize: 20,
            mt: "10px",
            alignSelf: "flex-start",
            color: isReview()
              ? Theme.palette.primary.main
              : Theme.palette.action.disabled,
            cursor: isReview() ? "pointer" : "not-allowed",
          }}
          onClick={() => handleArrowClick(artifacts, "review")}
        />
      )} */}
    </Box>
  );
};

export default ReviewComponent;
